const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export interface GeoSuggestion {
  title: string;
  subtitle: string;
  uri: string;
}

export interface ResolvedAddress {
  yandexAddressId: string;
  formattedAddress: string;
  city: string;
  street: string;
  house: string;
  lat?: number;
  lng?: number;
}

export const geocoderApi = {
  async suggest(q: string): Promise<GeoSuggestion[]> {
    if (!q.trim()) return [];
    const res = await fetch(`${API_URL}/geocoder/suggest?q=${encodeURIComponent(q)}`);
    if (!res.ok) return [];
    const data = await res.json();
    return data.results ?? [];
  },

  async resolve(uri?: string, text?: string): Promise<ResolvedAddress | null> {
    const params = new URLSearchParams();
    if (uri) params.set('uri', uri);
    else if (text) params.set('text', text);
    else return null;
    const res = await fetch(`${API_URL}/geocoder/resolve?${params}`);
    if (!res.ok) return null;
    const data = await res.json();
    return data.address ?? null;
  },

  async resolveByCoords(lat: number, lng: number): Promise<ResolvedAddress | null> {
    const res = await fetch(
      `${API_URL}/geocoder/resolve?lat=${lat}&lng=${lng}`,
    );
    if (!res.ok) return null;
    const data = await res.json();
    return data.address ?? null;
  },
};
